import { SettingOutlined } from '@ant-design/icons'
import { Tooltip, theme } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { SETTINGS_ROOT, useNavigationMode } from '../../layouts/AppShell/useNavigationMode'

/** Opens settings. Choosing between company, organisation and own settings happens in the settings sider. */
const SettingsMenu = () => {
  const { t } = useTranslation()
  const { mode } = useNavigationMode()
  const {
    token: { colorPrimary, colorBgContainer, borderRadius }
  } = theme.useToken()
  const active = mode === 'settings'

  return (
    <Tooltip title={t('menu:/settings', 'Asetukset')}>
      <Link
        to={SETTINGS_ROOT}
        className="settings-menu"
        style={{
          display: 'inline-flex',
          padding: 6,
          borderRadius,
          color: active ? colorPrimary : 'inherit',
          // Same tint as the selected side menu item
          background: active ? `color-mix(in srgb, ${colorPrimary} 14%, ${colorBgContainer})` : undefined
        }}
      >
        <SettingOutlined />
      </Link>
    </Tooltip>
  )
}

export default SettingsMenu
